import { api } from '../../../utils';

const baseUrl = '/profiles/cron';

const cronTemplatesApi = {
  getCronProfiles: () => api.get(baseUrl),

  addCronProfile: data => api.post(baseUrl, data),

  editCronProfile: (id, body: { cron; name }) => api.put(`${baseUrl}/${id}`, body),

  deleteCronProfile: id => api.delete(`${baseUrl}/${id}`)
};

export default cronTemplatesApi;
